import { Injectable } from "@angular/core";
import en from "../../../../assets/i8tn/ppm/en.json";
import id from "../../../../assets/i8tn/ppm/id.json";
@Injectable({
  providedIn: "root",
})
export class CustomTranslationService {
  currentLanguage = localStorage.getItem("language");

  wording = this.getLanguage();
 
  constructor() { }

  getLanguage() {
    if (this.currentLanguage === "English") {
      return en;
    } else if (this.currentLanguage === "Indonesia") {
      return id;
    } else {
      return en;
    }
  }
}
